export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3a2 2 0 012 2v10a2 2 0 01-2 2h-6v5h-4v-5H4a2 2 0 01-2-2V5a2 2 0 012-2h16zM4 15h16V5H4v10z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};